import { render, staticRenderFns } from "./TemplateListingItemBase.vue?vue&type=template&id=f742c968&scoped=true&"
import script from "./TemplateListingItemBase.vue?vue&type=script&lang=js&"
export * from "./TemplateListingItemBase.vue?vue&type=script&lang=js&"
import style0 from "../../Style/template-listing-item-base.scss?vue&type=style&index=0&id=f742c968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f742c968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f742c968')) {
      api.createRecord('f742c968', component.options)
    } else {
      api.reload('f742c968', component.options)
    }
    module.hot.accept("./TemplateListingItemBase.vue?vue&type=template&id=f742c968&scoped=true&", function () {
      api.rerender('f742c968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Listings/TemplateListingItemBase.vue"
export default component.exports